import { render } from "./CanvasBoard.vue?vue&type=template&id=bdeaa2c4&scoped=true"
import script from "./CanvasBoard.vue?vue&type=script&lang=js"
export * from "./CanvasBoard.vue?vue&type=script&lang=js"

import "./CanvasBoard.vue?vue&type=style&index=0&id=bdeaa2c4&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdeaa2c4"]])

export default __exports__